import React from "react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error("App error boundary:", error, info?.componentStack);
    }

    handleReload = () => {
        try {
            window.location.reload();
        } catch {
            // ignore
        }
    };

    render() {
        if (!this.state.hasError) return this.props.children;
        return (
            <div
                role="alert"
                data-testid="error-boundary"
                className="min-h-screen grid place-items-center bg-[#0a0d14] text-white px-6 text-center"
            >
                <div className="max-w-md">
                    <p className="text-xs uppercase tracking-[0.2em] text-[var(--mbe-gold)]">
                        Something went wrong
                    </p>
                    <h1 className="font-display text-2xl sm:text-3xl font-bold mt-3">
                        We hit a small bump.
                    </h1>
                    <p className="mt-3 text-slate-400 text-sm">
                        Refresh the page to continue. If this keeps happening, try
                        again in a moment.
                    </p>
                    <button
                        onClick={this.handleReload}
                        className="btn-primary mt-6"
                        data-testid="error-reload-btn"
                    >
                        Reload page
                    </button>
                </div>
            </div>
        );
    }
}
